import React, { useEffect, useState } from 'react';
import { Box, IconButton, LinearProgress, Typography } from "@mui/material";
import { GENPDF } from "../../../services/actions";
import { useDispatch, useSelector } from "react-redux";
import ProgressBar from './ProgressBar';
import { BsX } from 'react-icons/bs';

export default function PDFReport({ camera, onClose = () => { } }) {
    const dispatch = useDispatch();
    const genpdfState = useSelector(state => state?.genpdfState);
    const now = new Date();
    const currentYear = now.getFullYear();
    const currentMonth = now.getMonth() + 1;

    const months = [
        'January', 'February', 'March', 'April', 'May', 'June',
        'July', 'August', 'September', 'October', 'November', 'December'
    ];

    const [selectedYear, setSelectedYear] = useState(currentYear);
    const [selectedMonth, setSelectedMonth] = useState(currentMonth);
    const [availableYears, setAvailableYears] = useState([]);
    const [availableMonths, setAvailableMonths] = useState([]);
    const [loading, setLoading] = useState(false);

    const onChangeYearMonth = () => {
        let payload = {
            "camera_id": camera?.id,
            "month": selectedMonth,
            "year": selectedYear,
            "location": "Qatar"
        }
        setLoading(true)
        dispatch({ type: `${GENPDF}_POST`, payload: payload, callback: () => setLoading(false) })
    }

    useEffect(() => {
        const years = [];
        for (let i = 0; i < 10; i++) {
            years.push(currentYear - i);
        }
        setAvailableYears(years);
    }, [currentYear]);

    useEffect(() => {
        const maxMonth = selectedYear === currentYear ? currentMonth : 12;
        const monthsToShow = months.slice(0, maxMonth);
        setAvailableMonths(monthsToShow);

        // If the current selectedMonth is not in the new list, reset it
        if (selectedMonth > maxMonth) {
            setSelectedMonth(maxMonth);
        }
        onChangeYearMonth()
    }, [selectedYear, currentYear, currentMonth, selectedMonth, camera]);

    return (
        <Box>
            <Box display={'flex'} justifyContent={'center'} gap={2} sx={{ py: 2 }}>
                <Box sx={{ minWidth: 200, display: 'flex', color: 'white', alignItems: 'center', gap: 1 }}>
                    <Typography fontSize={11}> Select Year</Typography>
                    <label>

                        <select
                            style={{ padding: 1, paddingLeft: 5, paddingRight: 5, minWidth: 80 }}
                            value={selectedYear}
                            onChange={(e) => setSelectedYear(parseInt(e.target.value))}
                        >
                            {availableYears.map((year) => (
                                <option key={year} value={year}>
                                    {year}
                                </option>
                            ))}
                        </select>
                    </label>
                </Box>
                <Box sx={{ minWidth: 150, display: 'flex', color: 'white', alignItems: 'center', gap: 1 }}>
                    <Typography fontSize={11} sx={{ textWrap: 'nowrap' }}> Select Month</Typography>
                    <select
                        style={{ padding: 1, paddingLeft: 5, paddingRight: 5 }}
                        value={selectedMonth}
                        onChange={(e) => setSelectedMonth(parseInt(e.target.value))}
                    >
                        {availableMonths.map((month, index) => (
                            <option key={index} value={index + 1}>
                                {month}
                            </option>
                        ))}
                    </select>

                </Box>
                <Box onClick={() => onClose()} sx={{ cursor: 'pointer', display: 'flex', color: 'red', alignItems: 'center', justifyContent: 'flex-end' }}>
                    <IconButton sx={{ background: 'black', color: '#ffd80c', p: 0 }} onClick={() => onClose()}>
                        <BsX fontSize={28} />
                    </IconButton>
                </Box>
            </Box>
            <Box>
                {loading && <ProgressBar />}
                {!loading && <Box sx={{ height: '78vh' }}>
                    <iframe
                        src={genpdfState?.data?.pdf_url}
                        width="100%"
                        height="100%"
                        style={{ border: 'none' }}
                        title="PDF Preview"
                    />
                </Box>}
            </Box>
        </Box>
    );
}
